/* eslint-disable no-nested-ternary */
import { Box, CircularProgress } from '@mui/material';
import { Container } from './styles';

import { InfoCard } from '../../../components/InfoCard';
import { ListaReuniaoComMesAno } from '../../../services/requests';
import { SectionMeetingCard } from '../components/SectionMeetingCard';

interface MeetingsProps {
  reunioes: ListaReuniaoComMesAno[] | undefined;
  loading: boolean;
  checked: boolean;
}

export function ReunioesPassadas({
  reunioes,
  loading,
  checked,
}: MeetingsProps) {
  return (
    <Container>
      {loading ? (
        <Box paddingTop="200px">
          <CircularProgress />
        </Box>
      ) : reunioes && reunioes?.length > 0 ? (
        reunioes?.map(r => (
          <SectionMeetingCard
            key={r.data}
            listagemReunioes={r}
            isPast
            checked={checked}
          />
        ))
      ) : (
        <Box marginTop="250px">
          <InfoCard title="Nenhuma reunião encontrada" />
        </Box>
      )}
    </Container>
  );
}
